import { useState } from "react";
import { Board } from "./Board";

export function Game() {
  const [gameBoard, setGameBoard] = useState(Array(9).fill(""));
  const [currentPlayer, setCurrentPlayer] = useState("X");
  const [gameActive, setGameActive] = useState(true);
  const [status, setStatus] = useState("Ход: X");

  const handleCellClick = (index) => {
    if (gameBoard[index] === "" && gameActive) {
      const newBoard = [...gameBoard];
      newBoard[index] = currentPlayer;
      setGameBoard(newBoard);

      if (checkWin(newBoard)) {
        setStatus(`Победил ${currentPlayer}!`);
        setGameActive(false);
      } else if (newBoard.every((cell) => cell !== "")) {
        setStatus("Ничья!");
        setGameActive(false);
      } else {
        const nextPlayer = currentPlayer === "X" ? "O" : "X";
        setCurrentPlayer(nextPlayer);
        setStatus(`Ход: ${nextPlayer}`);
      }
    }
  };

  const checkWin = (board) => {
    const winConditions = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6],
    ];
    return winConditions.some((condition) =>
      condition.every((index) => board[index] === currentPlayer)
    );
  };

  const resetGame = () => {
    setGameBoard(Array(9).fill(""));
    setGameActive(true);
    setCurrentPlayer("X");
    setStatus("Ход: X");
  };

  return (
    <div>
      <Board gameBoard={gameBoard} onCellClick={handleCellClick} />
      <div id="status">{status}</div>
      <button onClick={resetGame}>Новая игра</button>
    </div>
  );
}
